import React, { useMemo } from 'react';
import ReactTable from 'react-table';

import { TGlobalFreelancersProps } from './types';
import { createGlobalFreelancerColumns } from './columns';
import { GlobalFreelancersFilters } from './filters';
import { useGlobalFreelancers } from './useGlobalFreelancers';

const GlobalFreelancersPage = ({ notification }: TGlobalFreelancersProps) => {
    const {
        content,
        pages,
        showPaginationBottom,
        loading,
        currentPage,
        filterOptionValuesToDisplay,
        allowedSortColumns,
        currentUrlParams,
        defaultSorted,
        filterOptionsLoaded,
        onFilterChange,
        onPageChange,
        onSortedChange,
        reloadData,
    } = useGlobalFreelancers({ notification });

    const tableColumns = useMemo(
        () => createGlobalFreelancerColumns(allowedSortColumns),
        [allowedSortColumns],
    );

    return (
        <div className="table-container">
            <GlobalFreelancersFilters
                filterOptionValuesToDisplay={filterOptionValuesToDisplay}
                currentUrlParams={currentUrlParams}
                onFilterChange={onFilterChange}
                reloadData={reloadData}
            />
            <ReactTable
                page={currentPage}
                pageSize={0}
                data={content}
                pages={pages}
                columns={tableColumns}
                className="table-content payroll-admin-table"
                loading={loading}
                noDataText={
                    loading || !filterOptionsLoaded ? '' : 'No workers found'
                }
                showPaginationBottom={showPaginationBottom}
                showPageSizeOptions={false}
                manual={true}
                defaultSorted={defaultSorted}
                onPageChange={onPageChange}
                onSortedChange={onSortedChange}
            />
        </div>
    );
};

export default GlobalFreelancersPage;
